const tk = (value) => value;
const fieldId = (value) => value;
export const REPORT_AUTHORITY_DEFINITION_FIELDS = Object.freeze([
    {
        id: fieldId('field.reports.definition.authorityClassification'),
        name: 'authorityClassification',
        labelKey: tk('reports.authority.fields.classification'),
        helpTextKey: tk('reports.authority.help.classification'),
        fieldType: 'select',
        options: [
            { value: 'INTERNAL_CONTROL', labelKey: tk('reports.authority.classification.internalControl') },
            { value: 'AUTHORITATIVE_FILING', labelKey: tk('reports.authority.classification.authoritativeFiling') },
        ],
        value: {
            submitBehavior: 'include',
            hiddenValuePolicy: 'preserve',
        },
        layout: { xs: 12, sm: 6, md: 6 },
    },
    {
        id: fieldId('field.reports.definition.authorityRegulator'),
        name: 'authorityRegulator',
        labelKey: tk('reports.authority.fields.regulator'),
        helpTextKey: tk('reports.authority.help.regulator'),
        fieldType: 'select',
        options: [
            { value: 'IRD', labelKey: tk('organization.regulatoryProfile.authority.IRD') },
            { value: 'SEBON', labelKey: tk('organization.regulatoryProfile.authority.SEBON') },
            { value: 'NRB', labelKey: tk('organization.regulatoryProfile.authority.NRB') },
            { value: 'FIU_NEPAL', labelKey: tk('organization.regulatoryProfile.authority.FIU_NEPAL') },
        ],
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
        layout: { xs: 12, sm: 6, md: 6 },
    },
    {
        id: fieldId('field.reports.definition.authorityTemplateId'),
        name: 'authorityTemplateId',
        labelKey: tk('reports.authority.fields.templateId'),
        helpTextKey: tk('reports.authority.help.templateId'),
        fieldType: 'text',
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
        layout: { xs: 12, sm: 6, md: 6 },
    },
    {
        id: fieldId('field.reports.definition.authorityTemplateVersion'),
        name: 'authorityTemplateVersion',
        labelKey: tk('reports.authority.fields.templateVersion'),
        fieldType: 'text',
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
        layout: { xs: 12, sm: 6, md: 6 },
    },
    {
        id: fieldId('field.reports.definition.authoritySubmissionChannel'),
        name: 'authoritySubmissionChannel',
        labelKey: tk('reports.authority.fields.submissionChannel'),
        helpTextKey: tk('reports.authority.help.submissionChannel'),
        fieldType: 'text',
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
        layout: { xs: 12, sm: 6, md: 6 },
    },
    {
        id: fieldId('field.reports.definition.authoritySourceReference'),
        name: 'authoritySourceReference',
        labelKey: tk('reports.authority.fields.sourceReference'),
        helpTextKey: tk('reports.authority.help.sourceReference'),
        fieldType: 'text',
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
        layout: { xs: 12, sm: 6, md: 6 },
    },
    {
        id: fieldId('field.reports.definition.authorityEffectiveFrom'),
        name: 'authorityEffectiveFrom',
        labelKey: tk('reports.authority.fields.effectiveFrom'),
        fieldType: 'date',
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
        layout: { xs: 12, sm: 6, md: 6 },
    },
    {
        id: fieldId('field.reports.definition.authorityEffectiveTo'),
        name: 'authorityEffectiveTo',
        labelKey: tk('reports.authority.fields.effectiveTo'),
        fieldType: 'date',
        value: { submitBehavior: 'include', hiddenValuePolicy: 'preserve' },
        layout: { xs: 12, sm: 6, md: 6 },
    },
]);
export function addReportAuthorityDefinitionFields(form) {
    if (String(form.id) !== 'form.reports.definition')
        return form;
    const existingNames = new Set(form.fields.map((field) => field.name));
    const additional = REPORT_AUTHORITY_DEFINITION_FIELDS.filter((field) => !existingNames.has(field.name));
    return {
        ...form,
        fields: [...form.fields, ...additional],
        sections: [
            ...(form.sections ?? []),
            {
                id: 'section.reports.definition.authority',
                titleKey: tk('reports.authority.section.title'),
                descriptionKey: tk('reports.authority.section.description'),
                fields: additional.map((field) => field.id),
                layout: { columns: 2 },
            },
        ],
        submission: {
            ...form.submission,
            includeFields: [
                ...(form.submission.includeFields ?? form.fields.map((field) => field.id)),
                ...additional.map((field) => field.id),
            ],
        },
    };
}
